<template>
  <section>
    <div class="mypooq-info-body">
      <div class="wrap">
        <div class="my-pay-wrap">
          <template v-if="!isLoading && dataList.length > 0">
            <table class="my-pay-table">
              <caption class="blind">
                이용권 내역
              </caption>
              <colgroup>
                <col style="width: 120px" />
                <col />
                <col style="width: 138px" />
                <col style="width: 138px" />
                <col style="width: 138px" />
                <col style="width: 138px" />
                <col style="width: 159px" />
              </colgroup>
              <thead>
                <tr>
                  <th>상태</th>
                  <th><div class="al">상품명</div></th>
                  <th>시작일</th>
                  <th>구매금액</th>
                  <th>만료일자</th>
                  <th>결제수단</th>
                  <th>자동결제</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(ticketItem, index) in dataList" :key="index">
                  <td>{{ ticketStatus(ticketItem) }}</td>
                  <td>
                    <div class="al">
                      <p class="my-pay-tit">
                        <strong>{{ ticketItem.productgroupname }}</strong
                        ><br />
                        <template v-if="ticketItem.productname"
                          ><span
                            v-html="replaceCircle(ticketItem.productname)"
                          ></span
                          ><br
                        /></template>
                        <template v-if="ticketItem.attributetext"
                          ><span
                            v-html="replaceCircle(ticketItem.attributetext)"
                          ></span
                          ><br
                        /></template>
                        <template v-if="ticketItem.issktstream === 'y'">
                          SKT 안심팩 이용 중
                        </template>
                      </p>
                      <p class="my-pay-text">{{ ticketItem.description }}</p>
                    </div>
                  </td>
                  <td>{{ ticketItem.startdate }}</td>

                  <td v-if="ticketItem.paymentmethod.startsWith('iTunes')">
                    {{ ticketItem.amount }}원
                  </td>
                  <td v-else>{{ getPriceText(ticketItem.amount) }}</td>
                  <td>{{ ticketItem.enddate }}</td>

                  <td>
                    <span class="table-inner-wrap">
                      <span>{{ ticketItem.paymentmethod }}</span>
                      <button
                        v-if="changeButton(ticketItem)"
                        class="pay-btn"
                        @click="changePaymentMethod(ticketItem)"
                      >
                        변경
                      </button>
                    </span>
                  </td>
                  <td
                    v-if="
                      ticketItem.autopayment === 'true' &&
                      !ticketItem.paymentmethod.startsWith('iTunes')
                    "
                  >
                    <template v-if="ticketItem.chargetypeid === '220'">
                      <span v-if="isExpire(ticketItem.enddate)"></span>
                      <span
                        v-else-if="ticketItem.autopaymentstatus === 'y'"
                        class="table-inner-wrap"
                      >
                        <span>자동결제 이용중</span>
                        <button
                          type="button"
                          class="subscription-btn"
                          @click="manageSubscription(ticketItem)"
                        >
                          구독 관리
                        </button>
                      </span>
                      <span
                        v-else-if="ticketItem.autopaymentstatus === 'n'"
                        class="table-inner-wrap"
                      >
                        <span>해지 신청 완료</span>
                        <button
                          type="button"
                          class="subscription-btn"
                          @click="manageSubscription(ticketItem)"
                        >
                          구독 관리
                        </button>
                      </span>
                    </template>
                    <template v-else>
                      <span v-if="isExpire(ticketItem.enddate)"></span>
                      <span
                        v-else-if="ticketItem.autopaymentstatus === 'y'"
                        class="table-inner-wrap"
                      >
                        <span>자동결제 이용중</span>
                        <button
                          class="pay-btn"
                          @click="unsubscribe(ticketItem)"
                        >
                          자동결제 해지
                        </button>
                      </span>
                      <span
                        v-else-if="ticketItem.autopaymentstatus === 'n'"
                        class="table-inner-wrap"
                      >
                        <span>해지 신청 완료</span>
                        <button
                          class="pay-cancel-btn"
                          @click="cancelUnsubscribe(ticketItem)"
                        >
                          해지 취소
                        </button>
                      </span>
                    </template>
                    <!-- 구독 관리
                    <span class="table-inner-wrap">
                      <button type="button" class="subscription-btn">구독 관리</button>
                    </span>
                    -->
                  </td>
                  <td
                    v-else-if="
                      ticketItem.autopayment === 'false' &&
                      !ticketItem.paymentmethod.startsWith('iTunes')
                    "
                  >
                    자동결제 대상이 아닙니다
                  </td>
                  <td v-else></td>
                </tr>
              </tbody>
            </table>

            <div class="bt-noti">
              <p class="dot-text">
                <span>
                  Wavve 홈페이지가 아닌 제휴 사이트에서 구매한 결합상품(SKT,
                  Bugs에서 구매한 상품 등)의 경우 Wavve 사이트에서 해지가
                  불가능합니다. 제휴사에 문의해주세요.
                </span>
              </p>
              <p class="dot-text">
                <span>
                  이용권 구매 후 콘텐츠 미사용 시, 7일 이내에 청약 철회가
                  가능합니다.
                </span>
              </p>
              <p class="dot-text">
                <span>
                  이용권 구매 후 7일이 경과 되었거나 콘텐츠를 사용한 경우 부분
                  환불이 진행될 수 있습니다. (할인 이벤트를 받아 이용권을 구매한
                  경우 할인 미적용 기준으로 환불 금액이 정산 됩니다.)
                </span>
              </p>
              <p class="dot-text">
                <span>
                  이용권 구매 후 청약 철회 또는 부분 환불을 원하시면 웨이브
                  <a
                    href="https://member.wavve.com/customer/qna/ask"
                    :style="highlightTextStyle"
                    >고객센터</a
                  >에 연락해 주시기 바랍니다.
                </span>
              </p>
            </div>

            <paging-component
              :current-page="currentPage"
              :page-count="totalCount"
              :limit="limit"
              :paging-count="pagingCnt"
              wrapper-class="paging-type02"
            />
          </template>

          <div v-if="!isLoading && dataList.length === 0" class="my-pay-empty">
            <empty-list text="이용권 결제 내역이 없어요."></empty-list>
          </div>

          <revocation-defense
            v-if="isShowRevocationDefense"
            :data="dataRevocationDefense"
            :close="closeRevocationDefense"
            :is-unsubscribe="isUnsubscribe"
          />

          <!-- 결제수단변경 팝업 -->
          <popup-change-payment
            v-if="isChangePaymentMethod"
            :data="dataChangePaymentMethod"
            :close="closeChangePaymentMethod"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import PagingComponent from '@/components/common/PagingComponent'
  import RevocationDefense from '@/components/mypooq/RevocationDefense'
  import PopupChangePayment from '@/components/mypooq/PopupChangePayment'
  import {
    getMypurchasePassCancel,
    getMypurchaseProducts,
  } from '@/common/utils/request'
  import {
    setDisableScrolling,
    setNumberCommas,
    titleTagNameChange,
  } from '@/common/utils/common'
  import EmptyList from '@/components/mypooq/EmptyList'
  import _ from 'lodash'
  import { USED_SUBSCRIPTION_TICKET } from '@/common/utils/eventbus.const'

  export default {
    components: {
      RevocationDefense,
      PagingComponent,
      PopupChangePayment,
      EmptyList,
    },
    data() {
      return {
        dataList: [],
        dataRevocationDefense: {}, // 해지 방어 팝업용 데이터
        isUnsubscribe: false, // 해지 방어 팝업용 플래그 true: 1차 해지방어, false: 2차 해지방어
        isShowRevocationDefense: false, // 해지 방어 팝업 표시 여부
        currentPage: 1,
        pagingCnt: 10,
        limit: 10,
        totalCount: 0,
        isChangePaymentMethod: false, // 결제수단변경팝업 표시여부
        dataChangePaymentMethod: {}, // 결제수단변경팝업 데이터
        isLoading: true,
        highlightTextStyle: {
          color: '#A5A5A5',
          textDecoration: 'underline',
        },
      }
    },
    watch: {
      isShowRevocationDefense() {
        this.setData()
      },
    },
    created() {
      titleTagNameChange('이용권내역 : 웨이브 MY')
      this.setData()
    },
    methods: {
      // 지정된 문자를 em 태그로 변경
      getPriceText(priceText) {
        if (priceText === '' || priceText.length === 0) return ''
        return isNaN(priceText) ? priceText : setNumberCommas(priceText) + '원'
      },
      replaceCircle(string) {
        return string.replace(/\$O\$/gi, '<span class="icon-dotted"></span>')
      },
      // 상태
      ticketStatus({ status, upcomingpayment }) {
        if (upcomingpayment) {
          return '결제 예약'
        }
        return status === 'y' ? '이용중' : '기간만료'
      },

      // 자동결제 해지
      unsubscribe(data) {
        setDisableScrolling(true)
        getMypurchasePassCancel({ userserviceid: data.userserviceid }).then(
          () => {
            this.isShowRevocationDefense = true
            this.isUnsubscribe = true
            this.dataRevocationDefense = data
          },
        )
      },
      // 자동결제 해지 취소
      cancelUnsubscribe(data) {
        setDisableScrolling(true)
        this.isShowRevocationDefense = true
        this.isUnsubscribe = false
        this.dataRevocationDefense = data
      },
      manageSubscription(subscriptionInfo) {
        const url = `https://play.google.com/store/account/subscriptions?sku=${subscriptionInfo.productid}&package=kr.co.captv.pooqV2`
        const goManagePage = confirm(
          'Google 앱 내 구매 이용권은 Google play 페이지에서만 해지 / 해지 취소가 가능합니다. Google play 페이지로 이동합니다.',
        )
        if (goManagePage) {
          window.open(url)
        }
      },
      // 해지방어 팝업 닫기
      closeRevocationDefense() {
        setDisableScrolling(false)
        this.isShowRevocationDefense = false
      },
      // 결제수단변경 팝업 열기
      changePaymentMethod(data) {
        setDisableScrolling(true)
        this.isChangePaymentMethod = true
        this.dataChangePaymentMethod = data
      },
      // 결제수단변경 팝업 닫기
      closeChangePaymentMethod() {
        setDisableScrolling(false)
        this.isChangePaymentMethod = false
      },
      isExpire(enddate) {
        let year = enddate.substring(0, 4)
        let month = parseInt(enddate.substring(5, 7)) - 1
        let day = enddate.substring(8, 10)
        let hour = enddate.substring(11, 13)
        let minute = enddate.substring(14, 16)
        let today = parseInt(new Date().getTime() / 1000)
        let endDay = new Date(year, month, day, hour, minute).getTime() / 1000
        return endDay - today <= 0
      },
      changeButton(ticketItem) {
        return (
          ticketItem.changemethod === 'y' && !this.isExpire(ticketItem.enddate)
        )
      },
      setData() {
        this.isLoading = true
        this.currentPage = Number(_.get(this.$route, ['query', 'page'], '1'))
        let offset = this.limit * (this.currentPage - 1)

        getMypurchaseProducts({
          startdate: '',
          enddate: '',
          producttype: 'pass',
          autopayment: 'n',
          offset,
          limit: this.limit,
          orderby: 'new',
        }).then(({ data }) => {
          this.dataList = _.get(data, 'list', [])
          if (this.dataList.length > 0) {
            this.$events.$emit(
              USED_SUBSCRIPTION_TICKET,
              _.get(this.dataList, '0', {}),
            )
          }
          this.totalCount = Number(_.get(data, 'pagecount', '1'))
          this.isLoading = false
        })
      },
    },
  }
</script>
